{
    "AllTelServer": "[Todos os servidores de telefonia]",
    "AnyPartition": "[Qualquer partição]",
    "AnyDevices": "[Qualquer dispositivo]",
    "AnyAgents": "[Qualquer Agente ACD]",
    "AnyAgentForDevice": "[Qualquer dispositivo definido]",
    "AnyDeviceForAgent": "[Qualquer com agente ACD definido]",
    "DeviceValidation": "Um administrador não pode ter um nível de permissão de dispositivo definido",
    "AgentValidation": "Um administrador não pode ter um nível de permissão de agente definido",
    "PermissionsLanguage_PermissionsNote": "Defina as permissões de nível de acesso do utilizador.",
    "PermissionsLanguage_CmEnvironment": "AGC:",
    "PermissionsLanguage_TelServer": "Servidor de telefonia:",
    "PermissionsLanguage_Partition": "Partição:",
    "PermissionsLanguage_Device": "Grupo \/ Dispositivo:",
    "PermissionsLanguage_AndOrAgent": "Agente:",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Este tipo de utilizador deve ter um dispositivo de permissão definido",
    "EssentialsDeviceValidation_MST": "Um utilizador CXA Standard deve ter um dispositivo de permissão definido",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Sincronizar permissões de supervisor da plataforma de telefonia",
    "BusinessManagerPartitionValidation": "Um gerente com acesso de administrador deve ter permissões para todas as partições (nível do sistema de telefonia).",
    "EssentialsDeviceValidation_MSTB": "Um usuário histórico deve ter um dispositivo de permissão configurado.",
    "ProfessionalDeviceValidation": "Um usuário profissional deve ter um dispositivo com permissões definidas.",
    "ProfessionalDeviceValidation_MSTB": "Um usuário em tempo real precisa ter um dispositivo com permissões configuradas."
}